
import { defineComponent, onMounted, onActivated, ref } from "vue";
import LandIncidentsTable from "@/components/tables/LandIncidentsTable.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import ToolbarIncidents from "@/layout/toolbar/land-incidents/ToolbarIncidents.vue";
import { subheaderDisplay } from "@/core/helpers/config";
import { computed } from "vue";
import MapComponentOL from "@/components/maps/MapComponentOL.vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "land-incidents-view",
  components: {
    LandIncidentsTable,
    ToolbarIncidents,
    MapComponentOL,
  },
  setup() {
    const store = useStore();
    let theToolbar = ref();
    let theMap = ref();
    let showAll = ref(false);
    let tableView = ref();
    let lastUUIDImage = null;
    let selectedIndex = ref(0);
    let infoSelectedIncident = ref(null) as any;
    let mode = ref(null) as any;
    const { t } = useI18n();
    const pageTitle = computed(() => {
      return store.getters.pageTitle;
    });
    const allLandIncidentsList = computed(() => {
      return store.getters.dataLandIncidentsList;
    });
    const landIncidentsList = computed(() => {
      return showAll.value
        ? store.getters.dataLandIncidentsList
        : store.getters.dataLandIncidentsList.length > 0
        ? [store.getters.dataLandIncidentsList[selectedIndex.value]]
        : null;
    });
    const selectedIncidentId = computed(() => {
      return store.getters.incidentIdSelected;
    });
    const refreshImage = (uuid) => {
      if (uuid != null) {
        store.commit(Mutations.SET_IMAGE_VISIBLE, true);
        if (!theMap.value.isImageLoaded(uuid)) {
          console.log("Refrescando imagen", uuid);
          store
            .dispatch(Actions.GET_IMAGE_BASE64, {
              siteId: siteId(),
              uuid: uuid,
            })
            .then(() => {
              console.log("End refreshImage");
              lastUUIDImage = uuid;
            });
        } else {
          theMap.value.setImageLayerVisible(uuid);
          console.log("Cargo imagen de cache");
        }
      }
    };

    let showImage = computed(() => {
      return store.getters.isImageVisible;
    });

    let imageData = computed(() => {
      return store.getters.dataImageBase64;
    });
    let mapView = computed(() => {
      return store.getters.dataMapView;
    });
    let imageIsLoading = computed(() => {
      return store.getters.imageIsLoading;
    });

    let siteViewParameters = computed(() => {
      return store.getters.dataSiteViewInfo;
    });

    function setMapView(view) {
      store.commit(Mutations.SET_MAP_VIEW, view);
    }

    function clickROW(uuid, index) {
      console.log("clickROW", uuid, index.value);
      if (allLandIncidentsList.value.length > 0) {
        if (index.value != 0)
          document
            .getElementsByTagName("tbody")[0]
            .getElementsByTagName("tr")
            [index - 3]?.scrollIntoView({ behavior: "smooth" });
        else
          document
            .getElementsByTagName("tbody")[0]
            .getElementsByTagName("tr")[0]
            .scrollIntoView({ block: "end" });
        selectedIndex.value = index.value;
        if (allLandIncidentsList.value[index.value]["ImageUUID"] != null) {
          refreshImage(uuid);
        } else {
          console.log("Estableciendo imagen visible a false");
          store.commit(Mutations.SET_IMAGE_VISIBLE, false);
        }
        console.log("Establishing infoSelectIncident");
        let modIncident = { ...allLandIncidentsList.value[index.value] };
        console.log(modIncident, "modIncident");
        modIncident["LandIncidentTypeID"] = getTextType(
          allLandIncidentsList.value[index.value]["LandIncidentTypeID"]
        );
        modIncident["LandIncidentCauseID"] = getTextCause(
          allLandIncidentsList.value[index.value]["LandIncidentCauseID"]
        );
        infoSelectedIncident.value = modIncident;
      }
    }

    const previousRow = () => {
      tableView.value.previousRow();
    };

    const nextRow = () => {
      tableView.value.nextRow();
    };

    const incidentClicked = (incidentID) => {
      console.log("incidentClicked", incidentID);
      let numberRow = allLandIncidentsList.value.findIndex(
        (incident) => incidentID == incident.Id
      );
      console.log("Has pinchado la fila", numberRow);
      tableView.value.setRow(numberRow);
    };
    const siteId = () => {
      return store.getters.getDefaultSiteId;
    };

    const list = computed(() => {
      return store.getters.dataLandIncidentsList;
    });
    console.log("list");
    console.log(list.value);
    const lastIncidentAdded = computed(() => {
      return store.getters.getlastDateIncidentAdded;
    });

    let propageDate = (arrayDate) => {
      theToolbar.value.setFilterDate(arrayDate);
    };
    store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");

    onActivated(() => {
      store.commit(Mutations.SET_IMAGE_VISIBLE, false);
      store.commit(Mutations.SET_CURRENTS_VISIBLE, false);
      store.commit(Mutations.SET_BREADCRUMB_MUTATION, {
        title: "seaIncidents",
      });
      if (lastIncidentAdded.value != null) {
        let startDate: Date = new Date();
        let endDate: Date = new Date();
        if (list.value.length > 0) {
          if (lastIncidentAdded.value < list.value[0].OccurrenceDateTime) {
            console.log("Soy menor que el primer registro");
            startDate = new Date(lastIncidentAdded.value.getTime());
            endDate = new Date(
              list.value[list.value.length - 1].OccurrenceDateTime.getTime()
            );
            loadData({
              startDate,
              endDate,
            });
          } else if (
            lastIncidentAdded.value >
            list.value[list.value.length - 1].OccurrenceDateTime
          ) {
            startDate = new Date(list.value[0].OccurrenceDateTime.getTime());
            endDate = new Date(lastIncidentAdded.value.getTime());
            console.log("Soy mayor que el último registro");
            loadData({
              startDate,
              endDate,
            });
          } else {
            console.log("Estoy entre ambos registros, refresco");
            // Its between, refresh
            startDate = new Date(list.value[0].OccurrenceDateTime.getTime());
            endDate = new Date(
              list.value[list.value.length - 1].OccurrenceDateTime.getTime()
            );
            loadData({
              startDate,
              endDate,
            });
          }
        } else {
          // Download from date to next 3 days
          startDate = new Date(lastIncidentAdded.value.getTime());
          endDate = new Date(lastIncidentAdded.value.getTime());
          endDate.setDate(endDate.getDate() + 3);
        }
        store.commit(Mutations.SET_LAST_DATE_LAND_INCIDENT_ADDED, null);
      }
      refreshImage(lastUUIDImage);
      if (document.getElementsByClassName("activeRow").length > 0) {
        setTimeout(function () {
          document.getElementsByClassName("activeRow")[0].scrollIntoView();
        }, 100);
      }
      if (allLandIncidentsList.value.length == 0) {
        store.commit(Mutations.SET_IMAGE_VISIBLE, false);
      } else {
        store.commit(Mutations.SET_IMAGE_VISIBLE, true);
      }
      theMap.value.resizeMap();
    });

    const changeShowAll = () => {
      showAll.value = !showAll.value;
      if (showAll.value) {
        mode.value = "selectIncident";
      } else {
        mode.value = null;
      }
    };
    const loadData = (filterDate = null as any) => {
      store.dispatch(Actions.ADD_BODY_CLASSNAME, "page-loading");
      // Check if lastDateIncidentAdded exists or null
      // if exists check if this date is between list dates
      // if is not, check if is less or greater than list dates
      // ask for new dates including lastDateIncidentAdded
      let filterStart =
        filterDate == null
          ? new Date(new Date().getFullYear(), 0, 1)
          : filterDate["startDate"];
      let filterEnd = filterDate == null ? new Date() : filterDate["endDate"];
      filterStart.setHours(0, 0, 0, 0);
      //if (filterDate == null) filterStart.setDate(filterStart.getDate() - 3);
      filterEnd.setHours(23, 59, 59, 0);
      store
        .dispatch(Actions.GET_LAND_INCIDENTS_LIST, {
          siteId: siteId(),
          startDate: filterStart.toISOString(),
          endDate: filterEnd.toISOString(),
          landIncidentTypeIds: filterDate
            ? filterDate["LandIncidentTypeID"]
            : [],
          landIncidentCauseIds: filterDate
            ? filterDate["LandIncidentCauseID"]
            : [],
        })
        .then((data) => {
          store.dispatch(Actions.REMOVE_BODY_CLASSNAME, "page-loading");
          propageDate([filterStart, filterEnd]);
          // Get initial base64 image
          // TODO: Arreglar Lista
          if (data.length > 0) {
            let modIncident = { ...allLandIncidentsList.value[0] };
            modIncident["LandIncidentTypeID"] = getTextType(
              allLandIncidentsList.value[0]["LandIncidentTypeID"]
            );
            modIncident["LandIncidentCauseID"] = getTextCause(
              allLandIncidentsList.value[0]["LandIncidentCauseID"]
            );
            infoSelectedIncident.value = modIncident;
            console.log("infoSelectedIncident", infoSelectedIncident.value);
          }
        });
    };

    const getTextCause = (causeID) => {
      const cause = store.getters.getCauseLandIncidents
        ? store.getters.getCauseLandIncidents.filter(
            (cause) => cause.Id == causeID
          )
        : null;
      return cause ? cause[0].Name : "checkError";
    };
    const getTextType = (typeID) => {
      const type = store.getters.getTypeLandIncidents
        ? store.getters.getTypeLandIncidents.filter((type) => type.Id == typeID)
        : null;
      return type ? type[0].Name : "checkError";
    };

    onMounted(() => {
      setCurrentPageBreadcrumbs(t("landIncidents"), []);
      loadData();
    });

    return {
      pageTitle,
      subheaderDisplay,
      refreshImage,
      imageData,
      landIncidentsList,
      selectedIncidentId,
      setMapView,
      mapView,
      theMap,
      clickROW,
      imageIsLoading,
      tableView,
      previousRow,
      nextRow,
      siteViewParameters,
      loadData,
      incidentClicked,
      changeShowAll,
      showAll,
      selectedIndex,
      infoSelectedIncident,
      mode,
      showImage,
      theToolbar,
    };
  },
});
